
import { Component, OnInit , ViewChild} from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { UserService } from '../../../../shared/user.service';


@Component({
  selector: 'app-quotation-approval-grid',
  templateUrl: './quotation-approval-grid.component.html',
  styleUrls: ['./quotation-approval-grid.component.css']
})
export class QuotationApprovalGridComponent implements OnInit {
  
  title="Quotation Approval";
  dtOptions: any = {};
  empList :any =[];
  mode :any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;


  constructor(public service : UserService) { }

  ngOnInit(): void {
    this.empList = this.service.empList;
    //
    this.dtOptions = {
      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', classname: 'btn btn-primary' }
      ],
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.columns().every(function () {
        const that = this;
        $('input', this.footer()).on('keyup change', function () {
          if (that.search() !== this['value']) {
            that
              .search(this['value'])
              .draw();
          }
        });
      });
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/Pages/purchase/quotation-approval/quotation-approval-grid/quotation-approval-grid.component.ts